import {Text} from 'evergreen-ui';

import {Referral, SelectedReferral} from '../../../referral';
import {SiblingReferralLink} from '../../../referral/component/siblings/SiblingReferralLink';

type Props = {
    referral: Referral;
};

export function SiblingReminder({referral}: Props) {
    const siblings = SelectedReferral.filterSiblingReferralsForOffer(referral);

    if (siblings.length === 0) {
        return null;
    }

    return (
        <>
            <Text fontWeight={500} className="mr-20">
                Also submit offer for siblings?
            </Text>
            <Text fontWeight={500} className="mr-2">
                Sibling:
            </Text>
            {
                siblings.map((s) => (
                    <SiblingReferralLink className="mr-2" key={s.guid} siblingReferral={s} toOfferForm={true}/>
                ))
            }
        </>
    );
}
